
import BasePageView from "components/core/BasePageView/BasePageView";
import useDDPoInvoiceFormLogic from "./useDDPoInvoiceFormLogic";
import DDPoInvoiceFormView from "./DDPoInvoiceFormView";
import DDPoInvoiceFormDesktop from "./DDPoInvoiceFormDesktop";

const DDPoInvoiceForm = () => {
    const vm = useDDPoInvoiceFormLogic();

    return (
        <BasePageView
            DesktopView={DDPoInvoiceFormDesktop}
            MobileView={DDPoInvoiceFormView}
            viewProps={vm}
        />
    );
};

export default DDPoInvoiceForm;
